import { Component, OnInit,TemplateRef} from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_PM_Itme_Interface, PM_Itme_Interface } from 'src/app/Interface/PM_Itme_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PM_ItemService } from 'src/app/Service/PM/PM_Item.service';

@Component({
  selector: 'app-PMItemList',
  templateUrl: './PMItemList.component.html',
  styleUrls: ['./PMItemList.component.scss']
})
export class PMItemListComponent implements OnInit {

  inner_PM_Item_Record:PM_Itme_Interface = Empty_PM_Itme_Interface()
  Filter_Title: string = ""

  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private PM_Item_Service: PM_ItemService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    public router: Router,
    private modalService: BsModalService
  ) { }


  DataList_PM: Array<PM_Itme_Interface> = []
  Data_Seleted_Delete: PM_Itme_Interface = Empty_PM_Itme_Interface()

  ngOnInit() {

    this.Nav_Service.CheckValidPage(1158).subscribe(
      data => {
        this.ReadData_PM()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_PM() {
    this.Procssing = true
    this.PM_Item_Service.GetRecord(this.inner_PM_Item_Record.id).subscribe(
      data => {
        this.DataList_PM = data
        this.Procssing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Set_Inner_PM_Item_Record(item:PM_Itme_Interface) {
    this.inner_PM_Item_Record = item

    this.ReadData_PM()
  }

  ReSet_Inner_PM_Item_Record() {
    this.inner_PM_Item_Record = Empty_PM_Itme_Interface()
    this.ReadData_PM()
  }

  Change_Filter() {
    this.page = 0
  }

  Delete(item: PM_Itme_Interface) {

    this.modalRef_Delete.hide()
    this.PM_Item_Service.DeletePM(item.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اعمال شد")
        this.ReadData_PM()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  //#region PM Form

  Selected_PM_Record: PM_Itme_Interface
  Selected_PM_Record_Switcher: string = 'List'
  Set_List_PM_View() {
    this.Selected_PM_Record_Switcher= 'List'
  }

  Set_Form_PM_View(item:PM_Itme_Interface,Switcher:string) {
    this.Selected_PM_Record = item
    this.Selected_PM_Record_Switcher= Switcher
  }

  Set_Form_PM_View_Add() {
    this.Selected_PM_Record = Empty_PM_Itme_Interface()
    this.Selected_PM_Record_Switcher= 'Form'
  }

  //#endregion


}
